<template>
  <div id="app" ref="app">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container">
        <div class="logo">知予 AI</div>
        <nav class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/profit">盈利模式</router-link>
          <router-link to="/services">产品服务</router-link>
          <router-link to="/blog">心理科普</router-link>
          <router-link to="/about">关于我们</router-link>
        </nav>
      </div>
    </header>

    <!-- 路由视图 -->
    <router-view />

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-logo">知予 AI</div>
          <div class="footer-links">
            <router-link to="/about">关于我们</router-link>
            <a href="#contact">联系我们</a>
          </div>
          <div class="footer-copyright">
            <p>© 2026 知予 AI 心理陪伴平台. 保留所有权利.</p>
            <p style="text-align: center;"><a href="https://beian.miit.gov.cn/" style="color: #00f;"
                target="_blank">辽ICP备2023010651号-29</a></p>
            
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 动画样式 */
.feature-card, .advantage-item, .scenario-card, .profit-card, .profit-related-card, .case-card, .process-step {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.feature-card.animate-in, .advantage-item.animate-in, .scenario-card.animate-in, .profit-card.animate-in, .profit-related-card.animate-in, .case-card.animate-in, .process-step.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* 为不同卡片添加交错动画延迟 */
.feature-card:nth-child(1) { transition-delay: 0.1s; }
.feature-card:nth-child(2) { transition-delay: 0.2s; }
.feature-card:nth-child(3) { transition-delay: 0.3s; }
.feature-card:nth-child(4) { transition-delay: 0.4s; }

.advantage-item:nth-child(1) { transition-delay: 0.1s; }
.advantage-item:nth-child(2) { transition-delay: 0.2s; }
.advantage-item:nth-child(3) { transition-delay: 0.3s; }
.advantage-item:nth-child(4) { transition-delay: 0.4s; }

.scenario-card:nth-child(1) { transition-delay: 0.1s; }
.scenario-card:nth-child(2) { transition-delay: 0.2s; }
.scenario-card:nth-child(3) { transition-delay: 0.3s; }

.profit-card:nth-child(1) { transition-delay: 0.1s; }
.profit-card:nth-child(2) { transition-delay: 0.2s; }
.profit-card:nth-child(3) { transition-delay: 0.3s; }

.profit-related-card:nth-child(1) { transition-delay: 0.1s; }
.profit-related-card:nth-child(2) { transition-delay: 0.2s; }
.profit-related-card:nth-child(3) { transition-delay: 0.3s; }

.case-card:nth-child(1) { transition-delay: 0.1s; }
.case-card:nth-child(2) { transition-delay: 0.2s; }
.case-card:nth-child(3) { transition-delay: 0.3s; }

.process-step:nth-child(1) { transition-delay: 0.1s; }
.process-step:nth-child(2) { transition-delay: 0.2s; }
.process-step:nth-child(3) { transition-delay: 0.3s; }
.process-step:nth-child(4) { transition-delay: 0.4s; }

body {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background-color: #f9f9f9;
  color: #333;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 导航栏 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #9c27b0;
}

.nav-links {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.nav-links a {
  text-decoration: none;
  color: #666;
  font-size: 16px;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #9c27b0;
}

/* 导航链接样式 */
.nav-links a i {
  margin-right: 5px;
  color: inherit;
}

/* 英雄区 */
.hero-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf1 100%);
  padding: 120px 0 80px;
  margin-top: 70px;
}

.hero-section .container {
  display: flex;
  align-items: center;
  gap: 50px;
  flex-wrap: wrap;
}

.hero-content {
  flex: 1;
  min-width: 300px;
}

.hero-title {
  font-size: 42px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.2;
}

.hero-slogan {
  font-size: 24px;
  color: #9c27b0;
  margin-bottom: 15px;
  font-weight: 600;
}

.hero-subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
  line-height: 1.5;
}

.hero-buttons {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.primary-btn {
  background: linear-gradient(135deg, #9c27b0, #7b1fa2);
  border: none;
  color: white;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(156, 39, 176, 0.3);
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(156, 39, 176, 0.4);
}

.secondary-btn {
  background-color: white;
  border: 2px solid #9c27b0;
  color: #9c27b0;
  padding: 10px 28px;
  font-size: 16px;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s;
}

.secondary-btn:hover {
  background-color: #f3e5f5;
  transform: translateY(-2px);
}

.hero-image {
  flex: 1;
  min-width: 300px;
  text-align: center;
}

.hero-image img {
  max-width: 100%;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

/* 通用section样式 */
section {
  padding: 80px 0;
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 60px;
  color: #333;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, #9c27b0, #7b1fa2);
  border-radius: 2px;
  margin: 20px auto 0;
}

/* 盈利模式区 */
.profit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf1 100%);
}

.profit-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.profit-card {
  background-color: white;
  padding: 40px 30px;
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.profit-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.profit-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #ff9800, #f57c00);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 32px;
}

.profit-title {
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.profit-details ul {
  list-style: none;
  padding: 0;
}

.profit-details li {
  margin-bottom: 15px;
  padding-left: 25px;
  position: relative;
  color: #666;
  line-height: 1.6;
}

.profit-details li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #4caf50;
  font-weight: bold;
}

/* 操作流程区 */
.process-section {
  background-color: white;
}

.process-steps {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  position: relative;
}

.process-steps::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, #9c27b0, transparent);
  transform: translateY(-50%);
  z-index: 0;
}

.process-step {
  text-align: center;
  position: relative;
  z-index: 1;
  background-color: white;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.process-step:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.step-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #9c27b0, #7b1fa2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 20px;
  font-weight: bold;
}

.step-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.step-desc {
  color: #666;
  line-height: 1.6;
}

/* 赚钱相关内容板块 */
.profit-related-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf1 100%);
}

.profit-related-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.profit-related-card {
  background-color: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.profit-related-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.profit-related-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #4caf50, #388e3c);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 32px;
}

.profit-related-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.profit-related-desc {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.profit-related-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.data-number {
  font-size: 32px;
  font-weight: bold;
  color: #4caf50;
  margin-bottom: 5px;
}

.data-label {
  font-size: 14px;
  color: #666;
}

/* 成功案例板块 */
.case-section {
  background-color: white;
}

/* 关于我们板块 */
.about-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf1 100%);
}

.about-content {
  display: flex;
  align-items: center;
  gap: 50px;
  flex-wrap: wrap;
}

.about-image {
  flex: 1;
  min-width: 300px;
}

.about-image img {
  max-width: 100%;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.about-text {
  flex: 1;
  min-width: 300px;
}

.about-subtitle {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.about-desc {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.about-features {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 30px;
}

.about-feature {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: white;
  padding: 15px 20px;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.about-feature:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.about-feature i {
  font-size: 20px;
  color: #9c27b0;
}

.about-feature span {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.case-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.case-card {
  background-color: #f9f9f9;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.case-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.case-image {
  height: 200px;
  overflow: hidden;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.case-card:hover .case-image img {
  transform: scale(1.1);
}

.case-title {
  font-size: 20px;
  font-weight: 600;
  margin: 20px 20px 10px;
  color: #333;
}

.case-desc {
  color: #666;
  line-height: 1.6;
  margin: 0 20px 20px;
}

.case-stats {
  display: flex;
  justify-content: space-around;
  padding: 20px;
  background-color: white;
  border-top: 1px solid #f0f0f0;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #9c27b0;
  display: block;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

/* 核心功能区 */
.features-section {
  background-color: white;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.feature-card {
  background-color: #f9f9f9;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  transition: all 0.3s;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #9c27b0, #7b1fa2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 32px;
}

.feature-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.feature-desc {
  color: #666;
  line-height: 1.6;
}

/* 产品优势区 */
.advantages-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf1 100%);
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
}

.advantage-item {
  text-align: center;
}

.advantage-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #2196f3, #0d47a1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 24px;
}

.advantage-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.advantage-desc {
  color: #666;
  line-height: 1.6;
}

/* 用户场景区 */
.scenarios-section {
  background-color: white;
}

.scenarios-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.scenario-card {
  background-color: #f9f9f9;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.scenario-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.scenario-image {
  height: 200px;
  overflow: hidden;
}

.scenario-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.scenario-card:hover .scenario-image img {
  transform: scale(1.1);
}

.scenario-title {
  font-size: 20px;
  font-weight: 600;
  margin: 20px 20px 10px;
  color: #333;
}

.scenario-desc {
  color: #666;
  line-height: 1.6;
  margin: 0 20px 20px;
}

/* 小程序引流区 */
.download-section {
  background: linear-gradient(135deg, #9c27b0, #7b1fa2);
  color: white;
  text-align: center;
}

.download-section .section-title {
  color: white;
}

.download-section .section-title::after {
  background: white;
}

.download-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
  flex-wrap: wrap;
}

.qrcode {
  background-color: white;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.qrcode img {
  width: 200px;
  height: 200px;
  margin-bottom: 10px;
}

.qrcode-text {
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.download-info {
  max-width: 400px;
  text-align: left;
}

.download-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 15px;
}

.download-desc {
  font-size: 18px;
  margin-bottom: 25px;
  line-height: 1.5;
}

.download-features {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.feature-tag {
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  border-radius: 20px;
  padding: 0 15px 5px;
  font-size: 14px;
}

/* 品牌信任区 */
.trust-section {
  background-color: white;
  text-align: center;
}

.trust-desc {
  max-width: 800px;
  margin: 0 auto 40px;
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.trust-logos {
  display: flex;
  justify-content: center;
  gap: 50px;
  flex-wrap: wrap;
}

.trust-logo {
  width: 150px;
  height: 60px;
  background-color: #f9f9f9;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: #666;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

/* 联系与支持区 */
.contact-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf1 100%);
}

.contact-content {
  display: flex;
  gap: 50px;
  flex-wrap: wrap;
}

.contact-info {
  flex: 1;
  min-width: 300px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
}

.contact-item i {
  font-size: 20px;
  color: #9c27b0;
}

.contact-form {
  flex: 1;
  min-width: 300px;
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.submit-btn {
  background: linear-gradient(135deg, #9c27b0, #7b1fa2);
  border: none;
  color: white;
  padding: 10px 30px;
  font-size: 16px;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(156, 39, 176, 0.3);
}

/* 页脚 */
.footer {
  background-color: #333;
  color: white;
  padding: 40px 0;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.footer-logo {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

.footer-links {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-links a {
  text-decoration: none;
  color: #ccc;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: white;
}

.footer-copyright {
  font-size: 14px;
  color: #999;
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 32px;
  }
  
  .hero-slogan {
    font-size: 20px;
  }
  
  .hero-subtitle {
    font-size: 16px;
  }
  
  .section-title {
    font-size: 28px;
  }
  
  .nav-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }
  
  .nav-links a {
    font-size: 14px;
  }
  
  .profit-content {
    grid-template-columns: 1fr;
  }
  
  .profit-related-content {
    grid-template-columns: 1fr;
  }
  
  .case-content {
    grid-template-columns: 1fr;
  }
  
  .about-content {
    flex-direction: column;
  }
  
  .about-features {
    justify-content: center;
  }
  
  .process-steps {
    grid-template-columns: 1fr;
  }
  
  .process-steps::before {
    display: none;
  }
  
  .download-content {
    flex-direction: column;
    text-align: center;
  }
  
  .contact-content {
    flex-direction: column;
  }
  
  .contact-info {
    text-align: center;
  }
  
  .contact-item {
    justify-content: center;
  }
}
</style>